import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { getCurrentMonth, getMonthInRussian } from "@/utils";

interface InsertAdditionalTimeForm {
  additionalTime: number;
}

const createFields: InputField[] = [
  {
    label: "Количество часов",
    name: "additionalTime",
    placeholder: "5, 10, -5",
    type: "text",
    pattern: /^-?\d*$/,
    patternMessage: "Введите корректное количество часов!",
    isRequired: true,
  },
];

export function InsertAdditionalTimeModal({
  disclosure,
  renterId,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  renterId: number;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: InsertAdditionalTimeForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      const period = getMonthInRussian(getCurrentMonth());

      api.meetingRooms
        .insertAddTime({
          amount: data.additionalTime,
          period: period,
          renter_id: renterId,
        })
        .then((_data) => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Добавление времени"
      modalErrors={modalErrors}
      fields={createFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
